import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './index.css';
import { withRouter } from 'react-router-dom';

class Header extends React.Component {
  state = {
    date: new Date().toLocaleDateString(),
  };

  handleClick = () => {
    const { history } = this.props;
    history.push('/project');
  };

  render() {
    return (
      <React.Fragment>
        <div className="container-bg">
          <Container>
            <Row className="py-4">
              <Col xs={{ span: 3 }}>
                <Link className="title" to="/">
                  ESP.
                </Link>
              </Col>
              <Col
                xs={{ span: 9 }}
                md={{ span: 9 }}
                className="d-flex flex-row-reverse center-flex"
              >
                <button
                  type="button"
                  className="btn btn-primary-outline font-weight-bold mx-2"
                  onClick={() => this.handleClick()}
                >
                  Projects
                </button>
                <span className="date"> {this.state.date} </span>
                <span className="line"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(Header);
